<template>
  <div class="text-center p-5">
    Signing you in…
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { setSiteAuthorized } from "@/auth/utils";

// next must be a path inside this portal; anything else goes home.
const safeNext = (raw) => {
  if (!raw || !raw.startsWith("/")) return "/";
  if (raw.startsWith("//") || raw.includes("\\")) return "/";
  if (/[\u0000-\u001f]/.test(raw)) return "/";
  if (raw === "/sso" || raw.startsWith("/sso?") || raw.startsWith("/sso#")) return "/";
  return raw;
};

export default {
  async created() {
    const params = new URLSearchParams(window.location.hash.slice(1));
    const token = params.get("token");
    const expireAt = Number(params.get("expireAt"));
    const next = safeNext(params.get("next"));

    // Remove the token from the address bar and the history entry immediately
    window.history.replaceState(null, "", "/sso");

    const now = Date.now() / 1000;

    // A person already signed in keeps their own session (their name stays in the audit trail)
    const current = this.$store.state.auth.accessToken;
    if (current && current.expireAt > now) {
      setSiteAuthorized();
      return this.$router.replace(next);
    }

    // Drop a stale session first: the $api interceptor redirects to /login
    // whenever the stored token has expired
    await this.$store.dispatch("auth/purgeAuth");
    if (!token || !(expireAt > now)) {
      return this.$router.replace({ name: "auth-login" });
    }

    try {
      await this.ssoLoginAsync({ token, expireAt });
      // The CASL instance only reads the store at app load, so refresh it
      this.$ability.update(this.$store.state.auth.ability);
      setSiteAuthorized();
      this.$router.replace(next);
    } catch (e) {
      await this.$store.dispatch("auth/purgeAuth");
      this.$router.replace({ name: "auth-login" });
    }
  },
  methods: {
    ...mapActions({
      ssoLoginAsync: "account/login/ssoLoginAsync",
    }),
  },
};
</script>
